<template>
    <div class="wrap white-bg">
        <div class="box1200">
            <div class="index-title">
                <h3 class="title">达人接单</h3>
                <p class="sort-title">人人都是推广者 轻松兼职赚钱</p>
            </div>
            <!--index-title-->
            <div class="Cbox">
                <div class="item" v-for="item in cList" :key="item.id">
                    <p class="icon"><img :src="item.imgUrl"></p>
                    <p class="title">{{item.title}}</p>
                    <p class="text">{{item.text}}</p>
                </div>
            </div>
            <router-link to="/daren-register/attestation" class="index-btn" v-if="this.$store.state.user_type === 3">成为达人</router-link>
            <router-link to="/list" class="index-btn" v-if="this.$store.state.user_type === 1 && this.$store.state.is_auth === 1">立即去抢单</router-link>
        </div>
    </div>
</template>
<script>
export default {
  name: 'HomePeople',
  data () {
    return {
      cList: [
        { id: '0', imgUrl: ('https://img.xiaochengdaren.com/2019101040880.png'), title: '个人流量变现', text: '提供长期且稳定的个人流量变现入口，让个人微信资源不再闲置浪费' },
        { id: '1', imgUrl: ('https://img.xiaochengdaren.com/2019101038753.png'), title: '随时随地接单', text: '无论何时何地，只要你有时间，随时随地接单转发赚取零花钱' },
        { id: '2', imgUrl: ('https://img.xiaochengdaren.com/2019101003195.png'), title: '提升个人营销技能', text: '提升个人社群资源管理能力，分类分组做精准传播，做价值的传播者' },
        { id: '3', imgUrl: ('https://img.xiaochengdaren.com/2019101021603.png'), title: '轻松兼职赚钱', text: '不影响生活和工作的节奏，点一点，转一转，轻松兼职' }
      ]
    }
  }
}
</script>
<style>
    .Cbox{margin-bottom:60px;}
    .Cbox .item{width:270px;height:320px;display:inline-block;margin-left:40px;text-align: center;-webkit-transition: all 0.3s ease-in;-moz-transition: all 0.3s ease-in;transition: all 0.3s ease-in;-o-transition: all 0.3s ease-in;}
    .Cbox .item:first-child{margin-left:0;}
    .Cbox .item:hover{box-shadow: 0 0 10px rgba(0,0,0,.1);border-radius:5px;}
    .Cbox .item .icon{margin-top:30px;}
    .Cbox .item .icon img{width:140px;height:140px;}
    .Cbox .item .title{font-size:16px;margin:15px 0 10px 0;}
    .Cbox .item .text{font-size:14px;color:#999;line-height:30px;padding:0 15px;}
</style>
